// Zakładka Energia (SPIS E-1) - przy koncie z własnym urządzeniem linii z energią (lista z opisu w Go): licznik kWh
// Sterownika NOW albo szacunek wędzarni z mocy i czasu pracy grzałki. Ten sam warunek dla pozycji menu i ekranu.
import { useSklad } from "../../brama/uzyj";
import { ENERGIA_LINII } from "../../gen/kontrakt";

export function useZLicznikiem(): boolean {
  return useSklad().some((d) => d.typ in ENERGIA_LINII && d.rola === "wlasciciel");
}
